import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CachedDataService } from '@services/data/cached-data.service';
import { AuthService } from '@services/http/auth.service';
import { ScreenService } from '@services/screen.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CONFIG } from '../../../config';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SignInComponent implements OnInit {
  signInForm: FormGroup;


  errorMessage = '';
  trySend = false;
  btnText = {
    text: 'Войти',
    default: 'Войти',
    loadText: 'Авторизация..'
  };
  btnTextDemo = {
    text: 'Демо-вход',
    default: 'Демо-вход',
    loadText: 'Авторизация..'
  };

  returnUrl: string;
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private cachedDataService: CachedDataService,
    private authService: AuthService,
    private screenService: ScreenService,
    private router: Router) { }

  ngOnInit() {
    this.screenService.isShowLoader = false;

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];

    console.log('init ' + this.returnUrl);
    this.initForm();
  }

  initForm() {
    this.signInForm = this.formBuilder.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]],
      remember: [false],
    });
  }

  onKeyUpField(event: any) {
    if (this.signInForm.get(event.target.name).touched && this.signInForm.get(event.target.name).errors) {
      this.signInForm.controls[event.target.name].setErrors({ 'error': null });
    }
  }
  onChangeUsername(value) {
    this.signInForm.controls['username'].setValue(value);
    this.cachedDataService.clearTempUsername();
  }

  demoSignIn() {
    this.signIn(CONFIG.demoUsername, CONFIG.demoPassword);
  }

  signIn(username?, password?) {
    if (this.trySend) {
      return false;
    }
    if (!username && !password) {
      /*if not demo signin */
      username = this.signInForm.value.username.replace(/\D/g, '');
      password = this.signInForm.value.password;
      if (this.signInForm.invalid) {
        this.errorMessage = 'Заполните обязательные поля.';
        return;
      }
      this.btnText.text = this.btnText.loadText;
    } else {
      this.btnTextDemo.text = this.btnTextDemo.loadText;
    }
    this.trySend = true;

    this.cachedDataService.setTempUsername(username);

    this.authService.signIn(username, password)
      .then((response) => {
        this.cachedDataService.clearTempUsername();
        this.trySend = false;
        this.cachedDataService.setCredentials({ 'username': username, 'password': password });
        this.cachedDataService.setToken(response.token);
        this.cachedDataService.setCurrentUser(response.user);
        this.cachedDataService.setExpiredDate(this.signInForm.value.remember);

        this.screenService.isShowLoader = true;

        if(this.returnUrl) {
          console.log('navigate to  ' + this.returnUrl);
          this.router.navigateByUrl(this.returnUrl);
        }
        else {
          this.router.navigate(['/personal', response.user.id]);
        }

      })
      .catch((error: any) => {
        this.trySend = false;
        this.btnText.text = this.btnText.default;
        this.btnTextDemo.text = this.btnTextDemo.default;
        if (error.error.errorMessage.length) {
          this.errorMessage = error.error.errorMessage;
        } else {
          const errors = error.error.modelState;
          for (error in errors) {
            this.signInForm.controls[errors[error].field.toLowerCase()].setErrors({ 'error': errors[error].errors });
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/view/auth/signin/signin.component.ts